import { combineReducers, configureStore, createSlice } from "@reduxjs/toolkit";
import userReducer from "./userSlice.js";
import messageReducer from "./messageSlice.js"; 
import socketReducer from "./socketSlice.js";

import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rerenderSlice = createSlice({
    name: "rerender",
    initialState: { value: 0 },
    reducers: {
        triggerRerender: (state) => {
            state.value += 1;
        },
    },
});

export const { triggerRerender } = rerenderSlice.actions;

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    blacklist: ['socket'],
};

const rootReducer = combineReducers({
    user: userReducer,
    message: messageReducer,
    socket: socketReducer,
    rerender: rerenderSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export default store;
